<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div>
    <v-card v-on:keyup.enter="buildNewSearch">
      <v-card-title>
        <h2>{{ onlyMine ? "Moje projekty" : "Wszystkie projekty" }}</h2>
        <v-spacer></v-spacer>
      </v-card-title>

      <v-layout align-center justify-center row>
        <v-flex xs2>
          <v-text-field
            browser-autocomplete="off"
            class="ma-2"
            v-model="searchedFields.projectCode"
            label="Nr projektu"
            aria-label="project code"
            for="all-projects-list-project-code"
            id="all-projects-list-project-code"
          ></v-text-field>
        </v-flex>
        <v-flex xs3>
          <v-autocomplete
            clearable
            class="ma-2"
            v-model="searchedFields.contestName"
            label="Nazwa konkursu"
            aria-label="contest name"
            id="all-projectslist-contest-name"
            for="all-projectslist-contest-name"
            :items="contestNameList"
          ></v-autocomplete>
        </v-flex>
        <v-flex xs2>
          <v-autocomplete
            clearable
            class="ma-2"
            v-model="searchedFields.bidderName"
            label="Nazwa oferenta"
            aria-label="bidder name"
            for="all-projectslist-bidder-name"
            id="all-projectslist-bidder-name"
            :items="bidderNameList"
          ></v-autocomplete>
        </v-flex>
        <v-flex xs2>
          <v-autocomplete
            class="ma-2"
            v-model="searchedFields.bidderLegalForm"
            :items="legalFormList"
            aria-label="bidder legal form"
            label="Forma prawna oferenta"
            for="all-projectslist-legal-form-bidder"
            id="all-projectslist-legal-form-bidder"
            clearable
          ></v-autocomplete>
        </v-flex>
        <v-flex xs2>
          <v-autocomplete
            class="ma-2"
            v-model="searchedFields.countryId"
            :items="countryList"
            item-text="name"
            item-value="id"
            label="Kraj projektu"
            aria-label="project country"
            for="all-projects-list-project-country"
            id="all-projects-list-project-country"
            clearable
          ></v-autocomplete>
        </v-flex>
      </v-layout>
      <v-layout align-center justify-center row>
        <v-flex xs2>
          <v-autocomplete
            class="ma-2"
            v-model="searchedFields.realizationYear"
            :items="yearList"
            label="Rok realizacji"
            aria-label="realization year"
            for="all-projects-list-project-realization-year"
            id="all-projects-list-project-realization-year"
            clearable
          ></v-autocomplete>
        </v-flex>
        <v-flex xs3>
          <v-autocomplete
            class="ma-2"
            v-model="searchedFields.projectStatus"
            :items="statusList"
            item-text="statusPL"
            item-value="statusEN"
            label="Status projektu"
            aria-label="project status"
            for="all-projects-list-project-status"
            id="all-projects-list-project-status"
            clearable
          ></v-autocomplete>
        </v-flex>
        <v-flex xs3>
          <v-autocomplete
            class="ma-2"
            v-model="searchedFields.arrearsStatus"
            :items="arrearsStatusList"
            item-text="name"
            item-value="id"
            label="Status płatności"
            aria-label="arrears status"
            for="all-projects-list-project-arrears-status"
            id="all-projects-list-project-arrears-status"
            clearable
          ></v-autocomplete>
        </v-flex>
        <v-flex xs3>
          <v-text-field
            :disabled="onlyMine"
            browser-autocomplete="off"
            class="ma-2"
            v-model="searchedFields.supervisorName"
            label="Nazwisko opiekuna"
            aria-label="project supervisor"
            for="all-projects-list-project-supervisor"
            id="all-projects-list-project-supervisor"
          ></v-text-field>
        </v-flex>
      </v-layout>
      <v-layout align-center justify-center row mb-3>
        <v-flex xs6 />
        <v-flex xs6>
          <v-layout align-center justify-center>
            <v-btn @click="buildNewSearch" color="primary" dark class="ma-2"
              >Szukaj</v-btn
            >
            <v-btn @click="resetSearch" color="primary" dark class="ma-2"
              >Resetuj</v-btn
            >
            <v-btn @click="exportData" color="primary" dark class="ma-2"
              >Eksportuj</v-btn
            >
            <span>
              <v-menu offset-y :disabled="!exportActive">
                <template v-slot:activator="{ on }">
                  <v-tooltip bottom :disabled="exportActive">
                    <template v-slot:activator="{ on: onTooltip }">
                      <div v-on="{ ...on, ...onTooltip }">
                        <v-btn color="primary" dark :disabled="!exportActive">
                          Eksport formularzy
                        </v-btn>
                      </div>
                    </template>
                    <span>{{ exportTooltip }}</span>
                  </v-tooltip>
                </template>
                <v-list>
                  <v-list v-for="(item, index) in exportMenu" :key="index">
                    <v-list-tile @click="openModal(item.type)">{{
                      item.label
                    }}</v-list-tile>
                  </v-list>
                </v-list>
              </v-menu>
            </span>
          </v-layout>
        </v-flex>
      </v-layout>

      <v-data-table
        :headers="headers"
        :rows-per-page-items="[10, 20, 25]"
        :items="projects"
        :pagination.sync="pagination"
        :total-items="itemCount"
        class="elevation-1"
      >
        <template v-slot:items="props">
          <td>
            {{ props.item.projectCode }}
            <v-tooltip bottom v-if="props.item.status == 'WITHDRAWN'">
              <template v-slot:activator="{ on }">
                <v-icon v-on="on" color="red" left style="margin-left: 5px"
                  >cancel</v-icon
                >
              </template>
              <div>
                <b>Anulowany</b>
              </div>
              <span>{{ props.item.withdrawalCause }}</span>
            </v-tooltip>
            <v-tooltip bottom v-if="props.item.status == 'FINISHED'">
              <template v-slot:activator="{ on }">
                <v-icon v-on="on" left style="margin-left: 5px"
                  >done_all</v-icon
                >
              </template>
              <div>
                <b>Zakończony</b>
              </div>
            </v-tooltip>
          </td>
          <td>{{ props.item.projectTitle }}</td>
          <td>
            {{ formatMoneyWithCode(props.item.agreementDonation, "PLN") }}
          </td>
          <td>
            <v-layout row>
              <v-flex shrink>
                {{ props.item.bidderName }}
              </v-flex>
              <v-flex v-if="props.item.mutualProject" pl-1 grow>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-icon v-on="on">groups</v-icon>
                  </template>
                  <span>Projekt wspólny z: {{ props.item.mutualBidderNames.join(", ") }}</span>
                </v-tooltip>
              </v-flex>
            </v-layout>
          </td>
          <td>{{ printAllCountries(props.item) }}</td>
          <td v-show="!onlyMine">{{ props.item.supervisorName }}</td>
          <td>
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn
                  icon
                  v-if="administratorPanel && !props.item.hideFromUser"
                  @click="goToProjectPanel(props.item)"
                >
                  <v-icon v-on="on"> business </v-icon>
                </v-btn>
              </template>
              <span>Panel projektu</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn
                  icon
                  v-if="!props.item.hideFromUser"
                  @click="showProject(props.item)"
                >
                  <v-icon v-on="on"> description </v-icon>
                </v-btn>
              </template>
              <span>Podgląd</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn
                  icon
                  v-if="
                    (roles.isAdministrator() ||
                      roles.isLocalAdministrator() ||
                      roles.isAgencyEmployee ||
                      roles.isDepartmentEmployee()) &&
                      !props.item.hideFromUser
                  "
                  @click="projectSummary(props.item)"
                >
                  <v-icon small v-on="on"> ballot </v-icon>
                </v-btn>
              </template>
              <span>Podsumowanie projektu</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn
                  icon
                  v-if="props.item.canDownloadSignedReportFile"
                  @click="navigateToFinalReportSigned(props.item)"
                >
                  <v-icon v-on="on">file_download</v-icon>
                </v-btn>
              </template>
              <span>Pobierz podpisane sprawozdanie</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn
                  icon
                  @click="showArrears(props.item.id)"
                  v-if="
                    (roles.isAdministrator() ||
                      roles.isLocalAdministrator() ||
                      roles.isDepartmentEmployee()) &&
                      !props.item.hideFromUser
                  "
                >
                  <v-icon
                    v-on="on"
                    :color="getColorByArrearsStatus(props.item.arrearsStatus)"
                  >
                    account_balance_wallet
                  </v-icon>
                </v-btn>
              </template>
              <span>{{
                getTitleByArrearsStatus(props.item.arrearsStatus)
              }}</span>
            </v-tooltip>
          </td>
        </template>
      </v-data-table>
    </v-card>
    <project-export-modal ref="projectExportModal" />
    <final-report-export-modal ref="finalReportExportModal" />
    <monitoring-export-modal ref="monitoringExportModal" />
    <volunteer-report-export-modal ref="volunteerExportModal" />

    <ProjectArrearsView
      :is-open.sync="showArrearsData"
      :arrears-data="arrearsData"
    />
  </div>
</template>

<script>
import { Api } from "@/api";
import { AccreditationCountry } from "@/api/generated/AccreditationCountry";
import { ContestRealizationYear } from "@/api/generated/ContestRealizationYear";
import { Pagination } from "@/utils/PaginationUtils";
import { ExportUtils } from "@/utils/ExportUtils";
import { Project } from "@/api/generated/Project";
import { Numbers } from "@/utils/Numbers";
import { Filters } from "@/utils/Filters";
import ProjectExportModal from "../../project/components/ProjectExportModal";
import FinalReportExportModal from "../../project/FinalReportExportModal";
import MonitoringExportModal from "../../project/MonitoringExportModal";
import VolunteerReportExportModal from "../../project/VolunteerReportExportModal";
import ProjectArrearsView from "../../project/ProjectArrearsView";
import { getDictionary } from "@/utils/LegalFormDictionary";
import { Files } from "@/utils/Files";

export default {
  name: "AllProjectsList",

  components: {
    ProjectArrearsView,
    VolunteerReportExportModal,
    MonitoringExportModal,
    FinalReportExportModal,
    ProjectExportModal,
  },

  mixins: [Numbers, Filters, Files],

  data() {
    return {
      headers: [
        {
          text: "Nr projektu",
          value: "projectCode",
          align: "left",
          sortable: true,
        },
        { text: "Nazwa projektu", value: "projectTitle", sortable: true },
        {
          text: "Kwota dotacji",
          value: "agreementDonation",
          sortable: false,
          width: "10%",
        },
        { text: "Nazwa oferenta", value: "bidderName", sortable: true },
        { text: "Kraje projektu", value: "country", sortable: true },
        { text: "Akcje", value: "action", sortable: false },
      ],
      itemCount: 0,
      pagination: {
        rowsPerPage: 25,
        sortBy: null,
      },
      projects: [],
      countryList: [],
      yearList: [],
      legalFormList: [],
      contestNameList: [],
      bidderNameList: [],
      search: "",
      exportActive: false,
      statusList: [
        { statusPL: "Nowy", statusEN: "NEW" },
        { statusPL: "Zaakceptowany", statusEN: "APPROVED" },
        { statusPL: "Oczekuje na poprawki", statusEN: "REQUESTED_CHANGES" },
        {
          statusPL: "Oczekuje na akceptację",
          statusEN: "POST_CORRECTION_MAIN",
        },
        { statusPL: "Poprawiony", statusEN: "CORRECTED" },
        { statusPL: "Umowa podpisana", statusEN: "AGREEMENT_SIGNED" },
        { statusPL: "Anulowany", statusEN: "WITHDRAWN" },
        { statusPL: "Zakończony", statusEN: "FINISHED" },
      ],
      arrearsStatusList: [
        { id: "NONE", name: "Brak zaległych płatności" },
        { id: "NOT_PAID", name: "Zaległe płatności" },
        { id: "PAID_OFF", name: "Zaległe płatności uregulowane" },
      ],

      searchedFields: Pagination.initSearchedFields([
        "projectCode",
        "countryId",
        "realizationYear",
        "projectStatus",
        "bidderLegalForm",
        "bidderName",
        "contestName",
        "onlyMine",
        "arrearsStatus",
        "supervisorName",
      ]),
      exportMenu: [
        { label: "Eksport projektów", type: "PROJECT_EXPORT" },
        {
          label: "Eksport raportów wolontariuszy",
          type: "VOLUNTEER_REPORT_EXPORT",
        },
        {
          label: "Eksport raportów z monitoringu",
          type: "MONITORING_REPORT_EXPORT",
        },
        { label: "Eksport sprawozdań końcowych", type: "FINAL_REPORT_EXPORT" },
      ],
      showArrearsData: false,
      arrearsData: null,
    };
  },

  created() {
    this.getCountryList();
    this.getYearList();
    this.getLegalFormList();
    this.getAllProjectContestNames();
    this.getAllProjectBidderNames();
    if (!this.onlyMine) {
      this.headers.splice(this.headers.length - 1, 0, {
        text: "Opiekun projektu",
        value: "supervisorName",
        sortable: false,
      });
    }
    this.searchedFields = this.retrieveFilters(this.searchedFields);
    this.pagination = this.retrievePagination(this.pagination);
  },

  props: {
    onlyMine: {
      default: false,
    },
    administratorPanel: {
      default: false,
    },
  },

  watch: {
    pagination: {
      handler(pagination) {
        this.getItemList();
        this.paginationRef = pagination;
      },
      deep: true,
    },

    searchedFields: {
      handler() {
        this.exportActive = false;
      },
      deep: true,
    },
  },

  computed: {
    searchedProjects() {
      return this.projects.filter(
        (project) => project.contestName === this.searchedFields.contestName
      );
    },

    projectCodes() {
      return this.searchedProjects.map((project) => project.projectCode);
    },

    searchedContestId() {
      let searchedContests = [
        ...new Set(this.searchedProjects.map((project) => project.contestId)),
      ];
      return searchedContests.length === 1 ? searchedContests[0] : null;
    },

    exportTooltip() {
      return this.searchedFields.contestName
        ? "Kliknij Szukaj"
        : "Wybierz konkurs i kliknij Szukaj";
    },
  },

  methods: {
    openProjectExportModal() {
      this.$refs.projectExportModal.openModal(
        { ...this.searchedFields },
        this.searchedContestId,
        "ALL"
      );
    },

    openFinalReportExportModal() {
      this.$refs.finalReportExportModal.openModal(
        { ...this.searchedFields },
        this.searchedContestId
      );
    },

    openMonitoringExportModal() {
      this.$refs.monitoringExportModal.openModal(
        { ...this.searchedFields },
        this.searchedContestId
      );
    },

    openVolunteerReportExportModal() {
      this.$refs.volunteerExportModal.openModal(
        { ...this.searchedFields },
        this.searchedContestId
      );
    },

    openModal(type) {
      switch (type) {
        case "PROJECT_EXPORT":
          this.openProjectExportModal();
          break;
        case "FINAL_REPORT_EXPORT":
          this.openFinalReportExportModal();
          break;
        case "VOLUNTEER_REPORT_EXPORT":
          this.openVolunteerReportExportModal();
          break;
        case "MONITORING_REPORT_EXPORT":
          this.openMonitoringExportModal();
          break;
      }
    },

    getColorByArrearsStatus(status) {
      switch (status) {
        case "NONE":
          return "green darken-1";
        case "NOT_PAID":
          return "lightred";
        default:
          return "success";
      }
    },

    getTitleByArrearsStatus(status) {
      switch (status) {
        case "NONE":
          return "Brak zaległych płatności";
        case "NOT_PAID":
          return "Zaległe płatności";
        default:
          return "Zaległe płatności uregulowane";
      }
    },

    showArrears(projectId) {
      Project.getArrears(
        this,
        projectId,
        (successResponse) => {
          this.arrearsData = successResponse;
          this.showArrearsData = true;
        },
        (errorResponse) => {
          this.$messagesBus.$emit(
            "error",
            "Nie udało się załadować zaległości projektu",
            errorResponse
          );
        }
      );
    },

    buildNewSearch() {
      this.search = this.buildSearchCriteria();
      this.exportActive = !!this.searchedFields.contestName;
      this.getItemList();
    },

    buildSort() {
      let order = this.pagination.descending ? "desc" : "asc";
      let columnName = this.pagination.sortBy;
      if (order && columnName) {
        return columnName.concat(" ").concat(order);
      } else {
        return "";
      }
    },

    exportData() {
      let search = this.search;
      let sort = this.buildSort();
      let endpointMainPath = "projects";
      let path =
        "/" +
        endpointMainPath +
        "/export?search=" +
        search +
        "&sort=".concat(sort);
      ExportUtils.sendExportRequest(path, this);
    },

    getItemList() {
      if (this.search === "") {
        this.search = this.buildSearchCriteria();
      }
      let sort = this.buildSort();
      Api.get(
        this,
        "/projects/list?search=" +
          this.search +
          "&page=" +
          this.pagination.page +
          "&result=" +
          this.pagination.rowsPerPage +
          "&sort=".concat(sort),
        (response) => {
          this.projects = response.itemList;
          this.itemCount = response.itemCount;
        }
      );
    },

    getAllProjectContestNames() {
      Project.getAllContestNames(
        this,
        this.onlyMine,
        (successResponse) => {
          this.contestNameList = successResponse.sort();
        },
        (errorResponse) => {
          this.$messagesBus.$emit(
            "error",
            "Nie udało się załadować nazw konkursów",
            errorResponse
          );
        }
      );
    },

    getAllProjectBidderNames() {
      Project.getAllBidderNames(
        this,
        this.onlyMine,
        (successResponse) => {
          this.bidderNameList = successResponse.sort();
        },
        (errorResponse) => {
          this.$messagesBus.$emit(
            "error",
            "Nie udało się załadować nazw oferentów",
            errorResponse
          );
        }
      );
    },

    buildSearchCriteria() {
      if (this.onlyMine) {
        this.searchedFields.onlyMine = true;
      }
      return Pagination.buildSearchCriteria(this.searchedFields, true);
    },

    showProject(project) {
      this.$router.openInNewTab("/view/project/".concat(project.id));
    },

    projectSummary(project) {
      this.$router.push("/app/project/" + project.id + "/summary");
    },

    resetSearch() {
      Pagination.resetSearch(this.searchedFields);
      this.search = "";
      this.exportActive = false;
      this.getItemList();
    },

    getCountryList() {
      AccreditationCountry.get(
        this,
        (successResponse) => {
          this.countryList = successResponse;
        },
        (errorResponse) => {
          this.$messagesBus.$emit(
            "error",
            "Nie udało się załadować krajów",
            errorResponse
          );
        }
      );
    },

    getYearList() {
      ContestRealizationYear.getList(
        this,
        (successResponse) => {
          this.yearList = successResponse.items.map((item) => item.value);
          this.yearList.sort(function(x, y) {
            return y - x;
          });
        },
        (errorResponse) => {
          this.$messagesBus.$emit(
            "error",
            "Nie udało się załadować lat realizacji projektów",
            errorResponse
          );
        }
      );
    },

    getLegalFormList() {
      let dict = getDictionary();
      for (let i = 0; i < Object.keys(dict).length; i++) {
        this.legalFormList.push(dict[i]);
      }
    },

    goToProjectPanel(item) {
      this.$router.push(
        "/app/"
          .concat(item.contestId)
          .concat("/project-panel/")
          .concat(item.id)
      );
    },

    printAllCountries(item) {
      let output = item.country;
      item.extraCountries.forEach(
        (country) => (output = output + ", " + country)
      );
      return output;
    },
    async navigateToFinalReportSigned(item) {
      await this.downloadFileAsBlob(
        this,
        this.getSignedProjectFile(item.id),
        item.signedReportFileName
      );
    },
  },
};
</script>

<style scoped></style>
